export const MODES = [
  { value: "test-tune", label: "Test & Tune" },
  { value: "race", label: "Race" },
];
export const BOX_MODES = [
  { value: "box", label: "Box" },
  { value: "no-box", label: "No Box" },
];
export const DISTANCES = [
  { value: "1/8", label: "1/8 Mile" },
  { value: "1/4", label: "1/4 Mile" },
];
export const VEHICLE_TYPES = [
  { value: "car", label: "Car" },
  { value: "motorcycle", label: "Motorcycle" },
  { value: "sled", label: "Sled" },
  { value: "jr-dragster", label: "Jr Dragster" },
];
export const LANES = [
  { value: "left", label: "Left" },
  { value: "right", label: "Right" },
];
export const RESULTS = [
  { value: "win", label: "Win" },
  { value: "loss", label: "Loss" },
  { value: "bye", label: "Bye" },
];
export const TRACK_CONDITIONS = [
  { value: "excellent", label: "Excellent" },
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" },
];

export function emptyRun() {
  return {
    date: new Date().toISOString().slice(0, 10),
    mode: "test-tune",
    boxMode: "no-box",
    distance: "1/4",
    vehicleType: "car",
    raceClass: "",
    track: "",
    lane: "",
    reactionTime: "",
    sixtyFoot: "",
    threeThirtyFoot: "",
    sixSixtyFoot: "",
    thousandFoot: "",
    et: "",
    speed: "",
    dialIn: "",
    opponentReactionTime: "",
    opponentET: "",
    opponentSpeed: "",
    opponentDialIn: "",
    result: "",
    tirePressureFront: "",
    tirePressureRear: "",
    engineTemp: "",
    airTemp: "",
    humidity: "",
    altitude: "",
    trackCondition: "",
    points: "",
    notes: "",
    ticketImageUri: null,
  };
}
